export enum ContactSuggestionReason {
    SIMILAR_TO_OTHER_ACCOUNTS = 'SIMILAR_TO_OTHER_ACCOUNTS',
    FOLLOW_UP = 'FOLLOW_UP',
    HAS_REPLIED = 'HAS_REPLIED',
    ANALYSIS_FROM_CONVERSATIONS = 'ANALYSIS_FROM_CONVERSATIONS',
    ANALYSIS_FROM_CONNECTIONS = 'ANALYSIS_FROM_CONNECTIONS',
}
